import { eArchiveApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { CompanyResponse } from 'src/types';

export const getCompanyListAll = (config: AxiosRequestConfig = {}) =>
  eArchiveApi.get<CompanyResponse[]>('/api/v1/companies/all', config);

export const getCompanyById = (companyId: string, config: AxiosRequestConfig = {}) =>
  eArchiveApi.get<CompanyResponse>(`/api/v1/companies/${companyId}`, config);
